import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/** @description common 토스트에 사용되는 state의 형태 */
export type TypeToast = {
  /** 렌더링 여부 */
  open: boolean;
  /** 지속시간 여부 */
  duration?: number | null;
  /** 모달 타입 */
  type?: 'info' | 'success' | 'error' | 'warning';
  /** 타이를로 표시될 메시지 */
  title?: string;
  /** 토스트에 표시될 메시지 */
  message?: string;
};

type TypeToastStore = {
  toast: TypeToast;
  actions: {
    setToast: (toast: TypeToast) => void;
  };
};

const initialState: TypeToast = {
  open: false,
  type: 'warning',
  duration: 1000,
  message: '',
};

/** @description 전역 토스트에 사용되는 토스트 표시 여부 및 토스트 관련 정보를 가지고 있는 상태 */
export const useToastStore = create<TypeToastStore>()(
  devtools((set) => ({
    toast: initialState,
    actions: {
      setToast: (toast: TypeToast) => set({ toast }),
    },
  }))
);
